module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-basilicata-luce-paesaggio.svg?2fd8caa0f8e1f4ad28fc1da3811dbb41";